import { render } from "./EmployeeDependents.vue?vue&type=template&id=e4dcbd78"
import script from "./EmployeeDependents.vue?vue&type=script&lang=js"
export * from "./EmployeeDependents.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__